import i18n from 'i18next';
// import HttpApi from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';

import config from 'config';

interface IProps {
  languages: string[];
  initialLanguage: string;
  onChange: (language: string) => void;
}

export const init = ({ languages, initialLanguage, onChange }: IProps) => {
  i18n.on('languageChanged', language => onChange(language));

  i18n
    .use(initReactI18next)
    // .use(HttpApi)
    .init({
      lng: initialLanguage,
      fallbackLng: initialLanguage,
      debug: ['local', 'development'].includes(config.app.env),
      whitelist: languages,
      interpolation: {
        escapeValue: false
      },
      ns: ['common'],
      defaultNS: 'common',
      // backend: {
      //   loadPath: `${config.app.public_url}/locales/{{lng}}/{{ns}}.json`, // Path to the translation files
      //   addPath: `${config.app.public_url}/locales/add/{{lng}}/{{ns}}`
      // },
      saveMissing: true,
      saveMissingTo: 'all',
      keySeparator: false,
      react: {
        useSuspense: true,
        wait: true
      }
    });
};
